import ApiService from "@/common/api/api.service";


const Anexo6_1 = {

    listar( empresaId, ano, anoFim, mesInicio, mesFim, ) {
        return ApiService.get(`Anexo61?Ano=${ano}${anoFim ? `&AnoFim=${anoFim}` : ''}${mesInicio ? `&MesInicio=${mesInicio}` : ''}${mesFim ? `&MesFim=${mesFim}`: ''}&EmpresaId=${empresaId}`);
    },

    salvarBaixas(form){
        return ApiService.put(`Anexo61`, form);
    }
}

export default Anexo6_1;
